import React from 'react';
export function App() {
  return <div className="w-full bg-white font-sans" data-id="element-0">
      <header className="w-full bg-blue-700 text-white py-4 px-4 md:px-8" data-id="element-1">
        <div className="max-w-4xl mx-auto flex justify-between items-center" data-id="element-2">
          <div className="text-sm" data-id="element-3">Arbeits Magazin | Gesundheit</div>
          <div className="text-sm" data-id="element-4">31. Juli 2025</div>
        </div>
      </header>
      <main className="w-full bg-white" data-id="element-5">
        <article className="max-w-4xl mx-auto px-4 md:px-8 py-6" data-id="element-6">
          {/* Headline */}
          <h1 className="text-2xl md:text-3xl font-bold text-red-600 mb-2" data-id="element-7">
            SCHOCKIERENDE WAHRHEIT: Warum 73% aller Schichtarbeiter unnötig
            leiden – und die 19,97€-Lösung, die alles verändert
          </h1>
          <h2 className="text-lg md:text-xl text-gray-700 mb-6" data-id="element-8">
            Eine Krankenschwester aus Hamburg bricht das Schweigen – und
            entdeckt eine Lösung, die ihr Leben verändert hat
          </h2>
          <div className="text-sm text-gray-500 mb-6" data-id="element-9">
            [Datum: 31. Juli 2025]
          </div>
          {/* Introduction */}
          <div className="mb-8" data-id="element-10">
            <p className="mb-4 text-base md:text-lg" data-id="element-11">
              Sandra M. aus Hamburg dachte nach 20 Jahren als Intensivpflegerin,
              dass brennende Füße und Rückenschmerzen einfach zum Job
              dazugehören. Bis zu dem Tag, der alles veränderte.
            </p>
            <div className="border-l-4 border-gray-300 pl-4 italic my-6" data-id="element-12">
              "Ich konnte nach einer 12-Stunden-Schicht kaum noch laufen",
              erzählt die 45-jährige Mutter mit tränenerstickter Stimme. "Meine
              Kinder sahen mich nur noch erschöpft auf dem Sofa liegen. Ich
              dachte ernsthaft daran, meinen Traumberuf aufzugeben."
            </div>
            <p className="mb-4" data-id="element-13">
              Was Sandra nicht wusste: Sie war – wie Millionen andere –
              jahrelang einem unsichtbaren Problem ausgeliefert, das ihre
              Gesundheit täglich zerstörte.
            </p>
          </div>
          {/* Problem Section */}
          <section className="mb-10" data-id="element-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#78C6E9] mb-4" data-id="element-15">
              DAS VERSCHWIEGENE PROBLEM, DAS KAUM JEMAND ANSPRICHT
            </h2>
            <p className="mb-4" data-id="element-16">
              Die erschreckende Wahrheit? Viele Arbeitsschuhe werden mit
              billigen Standard-Einlagen ausgeliefert, die kaum Unterstützung
              bieten – obwohl die Belastung im Alltag enorm ist.
            </p>
            <div className="flex flex-col md:flex-row gap-6 my-6" data-id="element-17">
              <div className="md:w-1/2" data-id="element-18">
                <img src="https://cdn.shopify.com/s/files/1/0945/0900/7113/files/ChatGPT_Image_31._Juli_2025_12_54_55.png?v=1753959455" alt="Erschöpfte Krankenschwester nach langer Schicht" className="w-full rounded-lg shadow-md" data-id="element-19" />
                <p className="text-sm text-center mt-2 text-gray-600" data-id="element-20">
                  Typischer Alltag für Millionen Schichtarbeiter
                </p>
              </div>
              <div className="md:w-1/2" data-id="element-21">
                <p className="mb-4" data-id="element-22">
                  Das perfide System dahinter: Je schneller Ihre Füße leiden,
                  desto öfter kaufen Sie neue Schuhe, Einlagen, Schmerzmittel.
                </p>
                <p className="mb-2" data-id="element-23">Das Resultat dieser Ignoranz:</p>
                <ul className="list-disc pl-6 my-4 space-y-2" data-id="element-24">
                  <li data-id="element-25">Fußschmerzen, die täglich schlimmer werden</li>
                  <li data-id="element-26">Knieprobleme durch Fehlbelastung</li>
                  <li data-id="element-27">Rückenschmerzen, die Sie nachts wachhalten</li>
                  <li data-id="element-28">Jeden Tag ein Stück mehr Lebensqualität verloren</li>
                </ul>
                <p className="font-semibold" data-id="element-29">
                  "Ich dachte jahrelang, das gehört einfach dazu", berichtet
                  Michael R., Lagerarbeiter aus München. "Niemand sagte mir,
                  dass es eine Lösung gibt."
                </p>
              </div>
            </div>
          </section>
          {/* Solution Section */}
          <section className="mb-10" data-id="element-30">
            <h2 className="text-xl md:text-2xl font-bold text-[#78C6E9] mb-4" data-id="element-31">
              DIE ENTDECKUNG, DIE ALLES VERÄNDERTE
            </h2>
            <p className="mb-4" data-id="element-32">
              Dann geschah etwas Außergewöhnliches. Ehemalige Schichtarbeiter
              aus Deutschland hatten genug von der täglichen Qual – und
              entwickelten gemeinsam mit Orthopädie-Experten eine völlig neue
              Art von Einlegesohle:
            </p>
            <p className="mb-4 font-bold" data-id="element-33">
              Cloudura – mit revolutionärer Cloudbounce-Dämpfung & medizinischer
              Stützschale für den härtesten Arbeitsalltag.
            </p>
            <p className="mb-4" data-id="element-34">
              Das ehrgeizige Ziel: Mehr Energie. Weniger Schmerzen. Endlich
              wieder Lebensqualität – selbst nach einem 10-Stunden-Tag auf den
              Beinen.
            </p>
            <div className="border-l-4 border-[#78C6E9] pl-4 italic my-6" data-id="element-35">
              "Als ich die ersten Prototypen testete, konnte ich es nicht
              glauben", erinnert sich Entwickler Thomas Weber. "Nach 15 Jahren
              eigener Schmerzen war ich zum ersten Mal nach einer Schicht
              schmerzfrei."
            </div>
            <div className="bg-blue-50 p-6 rounded-lg my-6" data-id="element-36">
              <h3 className="font-bold text-[#78C6E9] mb-3" data-id="element-37">
                DAS MACHT CLOUDURA SO AUSSERGEWÖHNLICH:
              </h3>
              <p className="mb-3" data-id="element-38">
                Im Gegensatz zu billigen Supermarkt-Einlagen wurde jedes Detail
                von Cloudura für deutsche Arbeitsbedingungen perfektioniert:
              </p>
              <ul className="space-y-3" data-id="element-39">
                <li className="flex items-start" data-id="element-40">
                  <span className="text-green-600 font-bold mr-2 mt-1" data-id="element-41">✅</span>
                  <span data-id="element-42">
                    <strong data-id="element-43">Druckpunkt-Massage-Effekt</strong> – aktiviert
                    gezielt die Fußzonen bei jedem Schritt für natürliche
                    Schmerzlinderung
                  </span>
                </li>
                <li className="flex items-start" data-id="element-44">
                  <span className="text-green-600 font-bold mr-2 mt-1" data-id="element-45">✅</span>
                  <span data-id="element-46">
                    <strong data-id="element-47">Cloudbounce-Dämpfung</strong> – absorbiert brutal
                    harte Stoßbelastung bei Beton, Fliesen und härtesten
                    Untergründen
                  </span>
                </li>
                <li className="flex items-start" data-id="element-48">
                  <span className="text-green-600 font-bold mr-2 mt-1" data-id="element-49">✅</span>
                  <span data-id="element-50">
                    <strong data-id="element-51">Stützende 3D-Schalenform</strong> – für ultimative
                    Stabilität, sicheren Halt und Eliminierung schädlicher
                    Fehlbelastung
                  </span>
                </li>
                <li className="flex items-start" data-id="element-52">
                  <span className="text-green-600 font-bold mr-2 mt-1" data-id="element-53">✅</span>
                  <span data-id="element-54">
                    <strong data-id="element-55">Universell einsetzbar</strong> – perfekt für
                    Sicherheitsschuhe, Sneaker und jeden Arbeitsschuh
                  </span>
                </li>
                <li className="flex items-start" data-id="element-56">
                  <span className="text-green-600 font-bold mr-2 mt-1" data-id="element-57">✅</span>
                  <span data-id="element-58">
                    <strong data-id="element-59">Getestet im echten Arbeitsalltag</strong> – von
                    verzweifelten Pfleger:innen, geplagten Handwerkern &
                    erschöpften Lagerkräften
                  </span>
                </li>
              </ul>
            </div>
            <div className="flex flex-col md:flex-row gap-6 my-6" data-id="element-60">
              <div className="md:w-1/2" data-id="element-61">
                <img src="https://cdn.shopify.com/s/files/1/0945/0900/7113/files/75132813027249390542-ezgif.com-optimize_1.gif?v=1753959445" alt="Cloudura Einlegesohlen im Einsatz" className="w-full rounded-lg shadow-md" data-id="element-62" />
                <p className="text-sm text-center mt-2 text-gray-600" data-id="element-63">
                  Die revolutionäre Cloudbounce-Technologie in Aktion
                </p>
              </div>
              <div className="md:w-1/2" data-id="element-64">
                <h3 className="font-bold text-lg mb-3" data-id="element-65">
                  TAUSENDE ZUFRIEDENE KUNDEN BRECHEN IHR SCHWEIGEN:
                </h3>
                <p className="mb-4" data-id="element-66">
                  Die Erfahrungsberichte, die uns täglich erreichen, sind
                  überwältigend:
                </p>
                <div className="bg-green-50 p-4 rounded-lg my-4" data-id="element-67">
                  <ul className="space-y-2" data-id="element-68">
                    <li className="flex items-start" data-id="element-69">
                      <span className="text-[#78C6E9] font-bold mr-2" data-id="element-70">✓</span>
                      <span className="italic" data-id="element-71">
                        "Ich arbeite 10 Stunden täglich im Lager auf Beton.
                        Teure Einlagen vom Orthopäden für 200€ haben nicht
                        geholfen – Cloudura schon nach einem einzigen Tag. Ich
                        kann es immer noch nicht fassen."
                      </span>
                    </li>
                    <li className="flex items-start mt-2" data-id="element-72">
                      <span className="text-[#78C6E9] font-bold mr-2" data-id="element-73">✓</span>
                      <span className="italic" data-id="element-74">
                        "Die Schmerzen in den Knien waren nach einer Woche fast
                        weg – ich hätte nie gedacht, dass Einlegesohlen so viel
                        verändern können. Meine Kollegen fragen alle, was mein
                        Geheimnis ist."
                      </span>
                    </li>
                    <li className="flex items-start mt-2" data-id="element-75">
                      <span className="text-[#78C6E9] font-bold mr-2" data-id="element-76">✓</span>
                      <span className="italic" data-id="element-77">
                        "Nach 20 Jahren Baustelle dachte ich, ich muss den Job
                        aufgeben. Cloudura hat mir meine Zukunft zurückgegeben.
                        Beste Investierung meines Lebens."
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          {/* Testimonials */}
          <section className="mb-10" data-id="element-78">
            <h2 className="text-xl md:text-2xl font-bold text-[#78C6E9] mb-4" data-id="element-79">
              EXKLUSIVES ANGEBOT – ABER NUR FÜR KURZE ZEIT
            </h2>
            <p className="mb-6" data-id="element-80">
              Normalerweise würden Sie für diese lebensverändernde Technologie
              deutlich mehr bezahlen. Heute haben Sie die Chance, Cloudura zu
              einem Bruchteil des regulären Preises zu testen:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8" data-id="element-81">
              <div className="bg-gray-50 p-5 rounded-lg border border-gray-200" data-id="element-82">
                <div className="flex items-center mb-3" data-id="element-83">
                  <div className="text-[#78C6E9] text-xl font-bold mr-2" data-id="element-84">
                    🔥
                  </div>
                  <div className="font-semibold text-lg" data-id="element-85">
                    Option 1 – Standarddeal
                  </div>
                </div>
                <div className="mb-4" data-id="element-86">
                  <p className="font-bold mb-2" data-id="element-87">
                    1 Paar Cloudura-Einlegesohlen
                  </p>
                  <p className="text-lg" data-id="element-88">
                    Statt 49,95€ jetzt nur{' '}
                    <span className="font-bold" data-id="element-89">29,95€</span>
                  </p>
                  <p className="text-sm mt-2 text-gray-600" data-id="element-90">
                    Ideal zum ersten Testen – aber nicht der intelligenteste
                    Deal
                  </p>
                </div>
                <a href="https://cloudura.de/products/cloudura-wolkensohle" className="block w-full" data-id="element-91">
                  <button className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded mt-2" data-id="element-92">
                    JETZT BESTELLEN
                  </button>
                </a>
              </div>
              <div className="bg-[#78C6E9]/10 p-5 rounded-lg border-2 border-[#78C6E9] relative" data-id="element-93">
                <div className="absolute -top-4 right-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-94">
                  BESTSELLER
                </div>
                <div className="flex items-center mb-3" data-id="element-95">
                  <div className="text-[#78C6E9] text-xl font-bold mr-2" data-id="element-96">
                    🏆
                  </div>
                  <div className="font-semibold text-lg" data-id="element-97">
                    Option 2 – Bestseller-Bundle (2 + 1 GRATIS)
                  </div>
                </div>
                <div className="mb-4" data-id="element-98">
                  <p className="font-bold mb-2" data-id="element-99">
                    Du kaufst 2 Paare – und bekommst 1 Paar GRATIS dazu
                  </p>
                  <p className="text-lg" data-id="element-100">
                    = nur{' '}
                    <span className="font-bold text-xl text-red-600" data-id="element-101">
                      19,97€
                    </span>{' '}
                    pro Paar!
                  </p>
                  <p className="text-sm mt-2 font-bold text-[#78C6E9]" data-id="element-102">
                    👉 Spare über 89,95€ gegenüber dem UVP!
                  </p>
                  <div className="mt-4 bg-white p-3 rounded-lg" data-id="element-103">
                    <p className="font-bold mb-2" data-id="element-104">
                      Was diesen Deal so wertvoll macht:
                    </p>
                    <ul className="space-y-2" data-id="element-105">
                      <li className="flex items-center" data-id="element-106">
                        <span className="text-green-600 font-bold mr-2" data-id="element-107">✓</span>
                        Gratis Premium-Versand (normalerweise 7,95€)
                      </li>
                      <li className="flex items-center" data-id="element-108">
                        <span className="text-green-600 font-bold mr-2" data-id="element-109">✓</span>
                        Gratis E-Book: „Schritte ohne Schmerzen" (Wert: 14,95€)
                      </li>
                      <li className="flex items-center" data-id="element-110">
                        <span className="text-green-600 font-bold mr-2" data-id="element-111">✓</span>
                        Perfekt für Alltag, Arbeit & Sport – oder zum
                        Verschenken
                      </li>
                    </ul>
                  </div>
                  <div className="flex items-center justify-between mt-4 text-sm text-gray-700" data-id="element-112">
                    <div data-id="element-113">📦 Größen individuell wählbar</div>
                    <div data-id="element-114">🔁 30 Tage Geld-zurück-Garantie</div>
                  </div>
                </div>
                <a href="https://cloudura.de/products/cloudura-wolkensohle" className="block w-full" data-id="element-115">
                  <button className="w-full bg-[#78C6E9] hover:bg-[#5ba8cb] text-white font-bold py-3 px-4 rounded-lg text-lg shadow-lg transform transition hover:scale-105" data-id="element-116">
                    2+1 BUNDLE SICHERN
                  </button>
                </a>
              </div>
            </div>
            <div className="overflow-x-auto my-8" data-id="element-117">
              <table className="w-full border-collapse" data-id="element-118">
                <thead data-id="element-119">
                  <tr className="bg-gray-100" data-id="element-120">
                    <th className="border p-2 text-left" data-id="element-121">Angebot</th>
                    <th className="border p-2 text-center" data-id="element-122">Preis</th>
                    <th className="border p-2 text-center" data-id="element-123">Preis pro Paar</th>
                    <th className="border p-2 text-center" data-id="element-124">Ihre Vorteile</th>
                  </tr>
                </thead>
                <tbody data-id="element-125">
                  <tr data-id="element-126">
                    <td className="border p-2" data-id="element-127">1 Paar</td>
                    <td className="border p-2 text-center" data-id="element-128">29,95€</td>
                    <td className="border p-2 text-center" data-id="element-129">29,95€</td>
                    <td className="border p-2" data-id="element-130">Standard-Versand</td>
                  </tr>
                  <tr className="bg-[#78C6E9]/10" data-id="element-131">
                    <td className="border p-2 font-bold" data-id="element-132">2 + 1 Gratis</td>
                    <td className="border p-2 text-center font-bold" data-id="element-133">59,90€</td>
                    <td className="border p-2 text-center font-bold" data-id="element-134">19,97€</td>
                    <td className="border p-2" data-id="element-135">
                      <span className="text-green-600 font-bold" data-id="element-136">✓</span> Gratis
                      Versand
                      <br data-id="element-137" />
                      <span className="text-green-600 font-bold" data-id="element-138">✓</span> Gratis
                      E-Book
                      <br data-id="element-139" />
                      <span className="text-green-600 font-bold" data-id="element-140">✓</span> 3-fach
                      testen, verschenken oder auf Vorrat sichern
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-center font-bold text-lg" data-id="element-141">
              Das sind über 50% Ersparnis – und Sie haben Einlagen für jeden
              Lebensbereich!
            </p>
          </section>
          {/* Urgency Section */}
          <section className="mb-10" data-id="element-142">
            <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-143">
              <h2 className="text-xl font-bold text-red-600 mb-4" data-id="element-144">
                ⚠️ WARNUNG: VERFÜGBARKEIT DRAMATISCH BEGRENZT
              </h2>
              <p className="mb-4" data-id="element-145">
                Hier wird es ernst: Die Nachfrage nach unserem 2+1-Bundle ist
                aktuell so explosiv, dass unsere Produktion kaum nachkommt.
              </p>
              <p className="font-semibold mb-4" data-id="element-146">Die schockierende Realität:</p>
              <ul className="space-y-2 mb-4" data-id="element-147">
                <li className="flex items-center" data-id="element-148">
                  <span className="text-red-600 font-bold mr-2" data-id="element-149">⚠️</span>
                  Unser Juli-Kontingent schmilzt täglich weiter zusammen
                </li>
                <li className="flex items-center" data-id="element-150">
                  <span className="text-red-600 font-bold mr-2" data-id="element-151">⚠️</span>
                  Es kann sein, dass wir den Bundle-Preis in den nächsten 48
                  Stunden wieder anheben müssen
                </li>
                <li className="flex items-center" data-id="element-152">
                  <span className="text-red-600 font-bold mr-2" data-id="element-153">⚠️</span>
                  Die nächste Nachproduktion ist zwar geplant, dauert aber
                  Wochen
                </li>
              </ul>
              <div className="bg-white p-3 rounded-lg my-4" data-id="element-154">
                <ul className="space-y-2" data-id="element-155">
                  <li className="flex items-center" data-id="element-156">
                    <span className="text-red-600 font-bold mr-2" data-id="element-157">⚠️</span>
                    Verfügbar nur solange unser Juli-Kontingent reicht
                  </li>
                  <li className="flex items-center" data-id="element-158">
                    <span className="text-red-600 font-bold mr-2" data-id="element-159">⚠️</span>
                    Nächste Lieferung frühestens Ende August
                  </li>
                  <li className="flex items-center" data-id="element-160">
                    <span className="text-red-600 font-bold mr-2" data-id="element-161">⚠️</span>
                    Dann wieder zum vollen Preis von 49,95€ pro Paar
                  </li>
                </ul>
              </div>
              <p className="italic" data-id="element-162">
                Sandra M. aus Hamburg warnt: „Ich habe zu lange gezögert und 20
                Jahre unnötig gelitten. Machen Sie nicht denselben Fehler."
              </p>
            </div>
          </section>
          {/* Decision Section */}
          <section className="mb-10" data-id="element-163">
            <h2 className="text-xl md:text-2xl font-bold text-[#78C6E9] mb-4" data-id="element-164">
              IHRE LEBENSVERÄNDERNDE ENTSCHEIDUNG – JETZT
            </h2>
            <p className="mb-4" data-id="element-165">
              In diesem Moment stehen Sie an einem Wendepunkt. Sie haben zwei
              Möglichkeiten:
            </p>
            <div className="border-t border-b py-6 my-6" data-id="element-166">
              <div className="flex flex-col md:flex-row gap-6" data-id="element-167">
                <div className="md:w-1/2 bg-gray-50 p-4 rounded-lg" data-id="element-168">
                  <h4 className="font-semibold mb-2" data-id="element-169">
                    Möglichkeit 1: Sie klicken weg, machen weiter wie bisher
                  </h4>
                  <p data-id="element-170">
                    – und leiden weitere Monate oder Jahre unter denselben
                    zermürbenden Schmerzen. Jeden Abend dieselbe Qual. Jeden
                    Morgen derselbe Kampf.
                  </p>
                </div>
                <div className="md:w-1/2 bg-[#78C6E9]/10 p-4 rounded-lg" data-id="element-171">
                  <h4 className="font-semibold mb-2" data-id="element-172">
                    Möglichkeit 2: Sie investieren 60 Sekunden, sichern sich das
                    2+1 Bundle
                  </h4>
                  <p data-id="element-173">
                    – und erleben bereits morgen früh, wie sich echte
                    Schmerzfreiheit anfühlt. Wie es ist, nach 10 Stunden Arbeit
                    noch Energie für Familie und Leben zu haben.
                  </p>
                </div>
              </div>
              <p className="text-center font-semibold mt-6" data-id="element-174">
                Die Wahl liegt in Ihren Händen.
              </p>
              <p className="text-center mt-2" data-id="element-175">
                Aber wählen Sie weise: Diese Chance kommt so schnell nicht
                wieder.
              </p>
            </div>
          </section>
          {/* Guarantee Section */}
          <section className="mb-10" data-id="element-176">
            <h2 className="text-xl md:text-2xl font-bold text-center mb-4" data-id="element-177">
              IHRE 100% RISIKOLOSE ERFOLGSGARANTIE
            </h2>
            <p className="text-center mb-6" data-id="element-178">
              Wir sind so überzeugt von Cloudura, dass wir Ihnen ein eisernes
              Versprechen geben:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-179">
              <div className="bg-blue-50 p-4 rounded-lg flex items-start" data-id="element-180">
                <span className="text-[#78C6E9] text-2xl font-bold mr-3" data-id="element-181">
                  🛡️
                </span>
                <span data-id="element-182">30 Tage vollständige Geld-zurück-Garantie</span>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg flex items-start" data-id="element-183">
                <span className="text-[#78C6E9] text-2xl font-bold mr-3" data-id="element-184">
                  🛡️
                </span>
                <span data-id="element-185">Nicht zufrieden? Jeder Cent zurück</span>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg flex items-start" data-id="element-186">
                <span className="text-[#78C6E9] text-2xl font-bold mr-3" data-id="element-187">
                  🛡️
                </span>
                <span data-id="element-188">Ohne lästige Fragen oder Diskussionen</span>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg flex items-start" data-id="element-189">
                <span className="text-[#78C6E9] text-2xl font-bold mr-3" data-id="element-190">
                  🛡️
                </span>
                <span data-id="element-191">Sie tragen kein Risiko – wir schon</span>
              </div>
            </div>
            <div className="text-center italic mt-6" data-id="element-192">
              Wie Sandra M. sagt: „Mit der Garantie hatte ich nichts zu
              verlieren – außer meinen Schmerzen. Beste Entscheidung meines
              Lebens."
            </div>
          </section>
          {/* Final CTA */}
          <section className="mb-10" data-id="element-193">
            <h2 className="text-xl md:text-2xl font-bold text-center text-[#78C6E9] mb-6" data-id="element-194">
              JETZT ZUGREIFEN – BEVOR ES ZU SPÄT IST
            </h2>
            <div className="bg-gray-50 p-6 rounded-lg border-2 border-[#78C6E9]" data-id="element-195">
              <div className="flex items-center justify-center mb-4" data-id="element-196">
                <span className="text-2xl mr-2" data-id="element-197">🎁</span>
                <h3 className="font-bold text-lg" data-id="element-198">
                  Ihr komplettes 2+1 Bundle enthält:
                </h3>
              </div>
              <ul className="space-y-3 mb-6" data-id="element-199">
                <li className="flex items-center" data-id="element-200">
                  <span className="text-[#78C6E9] font-bold mr-2" data-id="element-201">✓</span>
                  <span data-id="element-202">3 Paar Cloudura-Einlagen (Wert: 149,85€)</span>
                </li>
                <li className="flex items-center" data-id="element-203">
                  <span className="text-[#78C6E9] font-bold mr-2" data-id="element-204">✓</span>
                  <span data-id="element-205">Gratis Premium-Versand (Wert: 7,95€)</span>
                </li>
                <li className="flex items-center" data-id="element-206">
                  <span className="text-[#78C6E9] font-bold mr-2" data-id="element-207">✓</span>
                  <span data-id="element-208">
                    Gratis E-Book „Schritte ohne Schmerzen" (Wert: 14,95€)
                  </span>
                </li>
                <li className="flex items-center" data-id="element-209">
                  <span className="text-[#78C6E9] font-bold mr-2" data-id="element-210">✓</span>
                  <span data-id="element-211">30-Tage Geld-zurück-Garantie (unbezahlbar)</span>
                </li>
              </ul>
              <div className="flex flex-col md:flex-row justify-between items-center bg-white p-4 rounded-lg mb-6" data-id="element-212">
                <div data-id="element-213">
                  <p className="font-semibold" data-id="element-214">
                    Gesamtwert: <span className="line-through" data-id="element-215">172,75€</span>
                  </p>
                  <p className="text-xl font-bold" data-id="element-216">
                    Ihr Preis heute:{' '}
                    <span className="text-red-600" data-id="element-217">Nur 59,90€</span>
                  </p>
                  <p className="text-sm" data-id="element-218">= 19,97€ pro Paar – 65% Ersparnis!</p>
                </div>
                <div className="mt-4 md:mt-0" data-id="element-219">
                  <a href="https://cloudura.de/products/cloudura-wolkensohle" data-id="element-220">
                    <button className="bg-[#78C6E9] hover:bg-[#5ba8cb] text-white font-bold py-4 px-8 rounded-full text-xl shadow-lg transform transition hover:scale-105 flex items-center" data-id="element-221">
                      <span className="mr-2" data-id="element-222">🔒</span>
                      JETZT 2+1 BUNDLE SICHERN
                    </button>
                  </a>
                </div>
              </div>
              <div className="text-sm text-gray-600 mt-6" data-id="element-223">
                <p className="mb-2" data-id="element-224">
                  P.S.: Sandra M. schreibt uns regelmäßig: „Ich erzähle jedem
                  davon, der es hören will. Hätte ich nur früher bestellt."
                  Seien Sie nicht derjenige, der in 6 Monaten dasselbe bereut.
                </p>
                <p data-id="element-225">
                  P.P.S.: Das 2+1 Bundle ist nur verfügbar, solange unser
                  Juli-Vorrat reicht. Wenn Sie diese Seite schließen und später
                  wiederkommen, kann es bereits zu spät sein. Handeln Sie jetzt.
                </p>
              </div>
            </div>
          </section>
          <footer className="mt-10 pt-6 border-t text-sm text-gray-500" data-id="element-226"></footer>
        </article>
      </main>
    </div>;
}